module.exports = __webpack_public_path__ + "static/media/404.a0761d29.svg";